import {useTranslation} from "react-i18next";
import React, {memo} from 'react';

import {Icon} from "components/atoms";

import "../../../style.scss"


const Process = () => {
    const {t} = useTranslation()
    return (
        <div className="bazaar_current-item_process">
            <div>
                <Icon name="loading"/>
                <p>{t("processingTransaction")}</p>
            </div>
        </div>
    )
}

export default memo(Process);